import { useCallback } from 'react';
import FJModal from '../FJModal';
import FJDislikeReasonsModal from './FJDislikeReasonsModal';
import useLocalStore from '@src/hooks/useLocalStore';
import { FJModalsAction } from '@src/redux/action/FJModalsAction';
import { FJDetailsPageAction } from '@src/redux/action/FJDetailsPageAction';
import { useAppDispatch, useAppSelector } from '@src/redux/hooks';
import FJRequirementsUtil from '@src/util/FJRequirementsUtil';

export default function FJDislikeReasonsModalContainer() {
    useLocalStore();
    const dispatch = useAppDispatch();
    const { display, targetDetailId } = useAppSelector(state => state.modals.dislikeModalData);

    const onCancel = useCallback(() => {
        FJRequirementsUtil.eaLog('short_card_dislike_cancel');

        dispatch(FJModalsAction.hideDislikeModalAction());
    }, [dispatch]);

    const handleSubmit = useCallback(
        (keys: string[]) => {
            if (!targetDetailId) {
                dispatch(FJModalsAction.hideDislikeModalAction());
                return;
            }
            dispatch(FJDetailsPageAction.submitClipDislikeReasonsAction({ id: targetDetailId, keys }));
            dispatch(FJModalsAction.hideDislikeModalAction());
        },
        [dispatch, targetDetailId],
    );

    return (
        <FJModal visible={display} height=''>
            <FJDislikeReasonsModal onCancel={onCancel} onSubmit={handleSubmit} display={display} />
        </FJModal>
    );
}
